export enum TagTypes {
	SUCCESS = 'success',
	DANGER = 'danger',
	WARNING = 'warning',
}
